import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { SplitPaymentState, VatSummary } from '@skylab-shared/dataModel';
import { fillPlaceholders } from '@skylab-shared/utils';

interface DocumentAdjustmentSummaryInternalItem {
    splitPayment: SplitPaymentState;
    vatTable: {
        currencyId: number;
        items: {
            cost: number;
            gross: number;
            net: number;
            vat: number;
            vatRateId: number;
        }[]
    };
    currencyVatTable: {
        currencyId: number;
        items: {
            cost: number;
            gross: number;
            net: number;
            vat: number;
            vatRateId: number;
        }[]
    } | null;
}

export class DocumentAdjustmentSummaryQuery extends Query<VatSummary> {
    public constructor(public readonly documentId: number) {
        super();
    }
}

export class DocumentAdjustmentSummaryQueryHandlerBase implements QueryHandler<DocumentAdjustmentSummaryQuery, VatSummary> {
    private static Url = TaggedUrl.join('sales/:id/adjustmentSummary', [Tags.Api]); //TODO po zmianie w BE - document zamiast sale w urlu

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: DocumentAdjustmentSummaryQuery): Promise<VatSummary> {
        const url = fillPlaceholders(DocumentAdjustmentSummaryQueryHandlerBase.Url, { id: query.documentId });
        const { data } = await this.http.get<DocumentAdjustmentSummaryInternalItem>(url);

        const currencyVatTable = data.currencyVatTable;
        const vatTable = data.vatTable;

        return {
            splitPayment: data.splitPayment,
            currencyVatTable: currencyVatTable ? {
                currencyId: currencyVatTable.currencyId,
                items: currencyVatTable.items.map(i => ({
                    grossValue: i.gross,
                    netValue: i.net,
                    vatValue: i.vat,
                    vatRateId: i.vatRateId,
                    vatRate: null!
                }))
            } : null,
            vatTable: {
                currencyId: vatTable.currencyId,
                items: vatTable.items.map(i => ({
                    grossValue: i.gross,
                    netValue: i.net,
                    vatValue: i.vat,
                    vatRateId: i.vatRateId,
                    vatRate: null!
                }))
            }
        };
    }
}
